import { render } from "./editPeserta.vue?vue&type=template&id=5790204d"
import script from "./editPeserta.vue?vue&type=script&lang=js"
export * from "./editPeserta.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__